// Readable text from a failed API call: the server's own message(s) when there are any,
// e.g. "Ya existe un exportador con ese nombre.", otherwise `fallback`.
export function apiErrorText(err, fallback) {
  const data = err?.response?.data;
  if (typeof data === 'string') return fallback; // an HTML error page, not a message
  if (data?.detail) return String(data.detail);
  if (data && typeof data === 'object') {
    const text = Object.values(data).flat().filter((m) => typeof m === 'string').join(' ');
    if (text) return text;
  }
  return fallback;
}
